import { MutationOptions, useMutation } from 'react-query';
import { AppError } from 'utils/AppError';

export const useMutationV2 = <TData, TError = typeof AppError, TVariables = unknown>(
  mutationFn: (variables: TVariables) => Promise<TData>,
  options?: MutationOptions<TData, TError, TVariables>,
) => {
  return useMutation<TData, TError, TVariables>(mutationFn, options);
};
